import axios from "axios";
import { API_URL } from "./url-constant";
import { decryptAEStoString, toastEmitter } from "../utills/utilities";
import { store } from "../admin/hooks/redux/store";
import { clearLoggedUserReducer } from "../admin/hooks/redux/slice/logged-user";
import { ROUTES } from "../admin/routes/url-constant";
import { clearAccessTokenReducer } from "../admin/hooks/redux/slice/access-token";

const axioAdmin = axios.create({
    baseURL: `${API_URL.baseURL}`,
});
axioAdmin.interceptors.request.use(
    (config) => {
        let state = store.getState(),
            rawAccessToken = state?.accessToken?.value;
        rawAccessToken = rawAccessToken
            ? decryptAEStoString(rawAccessToken)
            : rawAccessToken;

        //  FIX: always set content type
        if (!config.headers["Content-Type"]) {
            config.headers["Content-Type"] = "application/json";
        }

        config.headers["Accept"] = "application/json";
        if (rawAccessToken) {
            config.headers.Authorization = `Bearer ${rawAccessToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
axioAdmin.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response.status === 401) {
            store.dispatch(clearAccessTokenReducer());
            store.dispatch(clearLoggedUserReducer());
            localStorage.clear();
            toastEmitter("error", "Session expired, please login again!");
            // redirect without using hooks
            window.location.href = ROUTES.ADMINLOGINPAGE;
        }
        return error.response;
    }
);


export default axioAdmin;
